import { constructEnum } from '@/lib/enum';

export default constructEnum('ThumbnailRatio', {
  SQUARE: 0,
  ORIGINAL: 10
});
